/**
 * Entry "root" do coruja standalone — substitui o que o esquilo fazia:
 * decide qual das 12 apps carregar baseado no JWT do usuário e
 * redireciona pra ela.
 *
 * Fluxo:
 *   1. bootstrap captura ?token= da URL (vindo do trex) → localStorage
 *   2. lê o token de localStorage
 *   3. se não tem token → manda pro trex (login)
 *   4. se tem mas o profile não mapeia → mostra erro + opção de logout
 *   5. se tem e mapeia → redireciona pra /src/apps/<app>/
 */
import { bootstrapTokenFromUrl } from '../../core/session/bootstrap';
import { getToken, clearToken } from '../../core/session/token-storage';
import {
  decodeJwtPayload,
  getAppForProfile,
} from '../../core/session/profile-router';
import { TREX_URL } from '../../core/config';

bootstrapTokenFromUrl();

const token = getToken();
const payload = token ? decodeJwtPayload(token) : null;
const app = payload
  ? getAppForProfile(payload.profile, payload.org_type)
  : null;

if (!token) {
  window.location.replace(TREX_URL || '/');
} else if (app) {
  const base = import.meta.env.BASE_URL || '/';
  window.location.replace(base + 'src/apps/' + app + '/');
} else {
  // Token presente mas profile+org_type não mapeia em nenhuma app.
  // Mostra mensagem clara com o payload em vez de loop com o trex.
  clearToken();
  document.getElementById('app').innerHTML =
    '<div style="font-family: Montserrat, sans-serif; padding: 2rem; max-width: 700px; margin: 2rem auto;">' +
    '<h2>Perfil não reconhecido</h2>' +
    '<p>O perfil deste usuário não pôde ser mapeado pra nenhuma das ' +
    'apps disponíveis.</p>' +
    '<p>Payload do JWT:</p>' +
    '<pre style="background:#f5f5f5;padding:1rem;border-radius:4px;overflow:auto;font-size:12px;">' +
    JSON.stringify(payload, null, 2) +
    '</pre>' +
    '<p style="margin-top:2rem;">' +
    '<a href="' + (TREX_URL || '/') + '/Seg/logoff.php">Fazer logout e tentar de novo</a>' +
    '</p>' +
    '</div>';
}
